import React from "react";
import whoImage from "assets/home-who.png";
import smiley from "assets/smilyS.png";

const HomeWillInfo = () => (
	<div id="home-breakout" className="flex max-lg:flex-wrap gap-8">
		<div className="bg-blue dark:bg-transparent font-normal shadow-none flex justify-start items-end lg:w-[50%] md:px-16 py-16 md:py-16">
			<div className="lg:max-w-[500px] max-lg:p-10 p-4">
				<div className="flex gap-4 items-center">
					<img
						className="relative w-[60px] h-[60px]"
						alt="smiley"
						src={smiley}
					/>
					<h1 className="font-bold text-darkblue dark:text-darkblue mb-0">
						75%+
					</h1>
				</div>
				<h3 className="uppercase font-bold">
					of UK adults do not
					<br />
					have a lasting power of attorney.
				</h3>
				<div className="text-sm flex gap-2 flex-col">
					<p>That&apos;s 3 in 4 people have no plans in place.</p>
					<p>
						In other words, the next time you&apos;re out with mates, 3 out of 4
						of you will have a firmer plan for your next round than for your
						financial future.
					</p>
					<p className="mt-1">“Another pint?”</p>
					<p className="mt-1">“Absolutely.”</p>
					<p className="mt-1">“Power of Attorney?”</p>
					<p className="mt-1">
						“…Errrr.”
						<br />
						Babycham for John. He&apos;s not in charge of anything.
					</p>
				</div>
			</div>
		</div>
		<div className="lg:w-[50%] relative bg-cover bg-center">
			<img className="h-[100%] object-cover" alt="pint" src={whoImage} />
			<div
				className="absolute top-[72%] left-[50%] bg-white p-2 text-center rounded-full w-[70%]"
				style={{ transform: "translateX(-50%)" }}
			>
				(Only smug-looking John has a will)
			</div>
		</div>
	</div>
);

export default HomeWillInfo;
